import { render } from "./CallMe.vue?vue&type=template&id=c9549e2a"
import script from "./CallMe.vue?vue&type=script&lang=js"
export * from "./CallMe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__